import React from 'react'
import { CContainer, CImage, CNavbar } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { logo } from 'src/assets/brand/logo'
import form_reforma_politica from 'src/assets/images/form/debate.png'
import form_encuesta from 'src/assets/images/form/img_climatico.png'
import PropTypes from 'prop-types'

function Header({ titulo, descripcion, organismo, propaganda, _imagen }) {
  const basePath = String(process.env.PUBLIC_URL).trim()
  return (
    <>
      <CNavbar color="primary">
        <CContainer style={{ width: '70%' }}>
          <a href={basePath + '/'}>
            <CIcon className="sidebar-brand-full" icon={logo} height={43} />
          </a>
        </CContainer>
      </CNavbar>
      {organismo && (
        <CNavbar>
          {Boolean(organismo) && (
            <CContainer style={{ width: '70%' }}>
              <h4 style={{ fontSize: '20px', fontWeight: 600, margin: '5px 0' }}>{organismo}</h4>
            </CContainer>
          )}
        </CNavbar>
      )}
      {propaganda && (
        <CContainer
          fluid
          style={{
            backgroundColor: organismo ? '#82A55A' : '#183F6A',
            padding: '30px 0',
            textAlign: 'center',
          }}
        >
          <CContainer className="form-img">
            {_imagen === 'form_reforma_politica' && (
              <CImage src={form_reforma_politica} className="form-img"></CImage>
            )}
            {_imagen === 'form_encuesta' && (
              <CImage src={form_encuesta} className="form-img"></CImage>
            )}
          </CContainer>
        </CContainer>
      )}
      <CContainer
        fluid
        style={{
          backgroundColor: Boolean(titulo) || Boolean(descripcion) ? '#F0F0E6' : '',
          padding: '30px 0',
        }}
      >
        <CContainer className="form-estilos-hd">
          <h1 className={propaganda ? 'form-titulo-propaganda' : 'form-titulo'}>{titulo}</h1>
          <div dangerouslySetInnerHTML={{ __html: descripcion }} />
        </CContainer>
      </CContainer>
    </>
  )
}

Header.propTypes = {
  organismo: PropTypes.string,
  titulo: PropTypes.string,
  descripcion: PropTypes.string,
  propaganda: PropTypes.bool,
  _imagen: PropTypes.string,
}

export default Header
